import { setInitialState } from "../../../../utils/reducerOperations";
export function Default() {
    return {
        storyboardTopicsApi: setInitialState(),
    };
}
